import { MapPin, Mail, Twitter, Facebook, Instagram, Linkedin } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <MapPin className="w-8 h-8 text-primary-400" />
              <h3 className="text-xl font-bold text-white ml-2">Nearbies</h3>
            </div>
            <p className="text-gray-400 mb-4">
              Discover local stores near you. Order online for pickup or delivery.
              Support your community.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* For Customers */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">For Customers</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://app.nearbies.co.uk" className="hover:text-primary-400 transition-colors">
                  Open Web App
                </a>
              </li>
              <li>
                <a href="#download" className="hover:text-primary-400 transition-colors">
                  Download App
                </a>
              </li>
              <li>
                <a href="#features" className="hover:text-primary-400 transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primary-400 transition-colors">
                  How It Works
                </a>
              </li>
            </ul>
          </div>

          {/* For Business */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">For Business</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://tilltech.co.uk" className="hover:text-primary-400 transition-colors">
                  Join as Merchant
                </a>
              </li>
              <li>
                <a href="https://tilltech.co.uk/pricing" className="hover:text-primary-400 transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#business" className="hover:text-primary-400 transition-colors">
                  Why Nearbies
                </a>
              </li>
              <li>
                <a href="https://app.tilltech.co.uk" className="hover:text-primary-400 transition-colors">
                  Merchant Login
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact & Support</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />
                <a href="mailto:support@nearbies.co.uk" className="hover:text-primary-400 transition-colors">
                  support@nearbies.co.uk
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-primary-400 transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/contact#delete-account" className="hover:text-primary-400 transition-colors">
                  Delete My Account
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; 2026 Nearbies. All rights reserved. Powered by{' '}
              <a href="https://tilltech.co.uk" className="text-primary-400 hover:text-primary-300">
                TillTech
              </a>
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
              <a href="/privacy" className="hover:text-primary-400 transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="hover:text-primary-400 transition-colors">
                Terms of Service
              </a>
              <a href="/cookies" className="hover:text-primary-400 transition-colors">
                Cookie Policy
              </a>
              <a href="/contact" className="hover:text-primary-400 transition-colors">
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
